import { memo } from "react";
import { CLAUDE_RESUME_COMPACTION_KEEP_ANSWER } from "@taskin-code/shared/claudeCompaction";
import { Minimize2 } from "~/lib/icons";
import { Button } from "../ui/button";
import { Tooltip, TooltipPopup, TooltipTrigger } from "../ui/tooltip";

export const ComposerResumeCompactionBanner = memo(function ComposerResumeCompactionBanner({
  tokenLabel,
  compactDisabled,
  compactDisabledReason,
  onCompact,
  onDismiss,
}: {
  tokenLabel: string;
  compactDisabled: boolean;
  compactDisabledReason: string | null;
  onCompact: () => void;
  onDismiss: () => void;
}) {
  const compactAction = (
    <Button
      size="xs"
      variant="outline"
      disabled={compactDisabled}
      onClick={() => {
        if (compactDisabled) return;
        onCompact();
      }}
    >
      Compactar
    </Button>
  );

  return (
    <div className="px-4 py-3.5 sm:px-5 sm:py-4">
      <div className="flex items-start gap-3">
        <Minimize2 className="mt-0.5 size-4 shrink-0 text-muted-foreground" aria-hidden="true" />
        <div className="min-w-0 flex-1">
          <div className="text-sm font-medium">Reanudar con menos contexto</div>
          <div className="mt-0.5 text-xs text-muted-foreground">
            {tokenLabel} tokens de una sesión anterior
          </div>
        </div>
        <div className="flex shrink-0 flex-wrap items-center justify-end gap-1.5">
          {compactDisabledReason ? (
            <Tooltip>
              <TooltipTrigger render={<span className="inline-flex">{compactAction}</span>} />
              <TooltipPopup side="top">{compactDisabledReason}</TooltipPopup>
            </Tooltip>
          ) : (
            compactAction
          )}
          <Button size="xs" variant="ghost" onClick={onDismiss}>
            {CLAUDE_RESUME_COMPACTION_KEEP_ANSWER}
          </Button>
        </div>
      </div>
    </div>
  );
});
